@file:kotlin.js.JsExport
package com.narbase.letsgo.web.dto.rides

import com.narbase.letsgo.web.dto.cartypes.CarTypeDto
import com.narbase.letsgo.web.dto.currency.CurrencyDto
import com.narbase.letsgo.web.dto.drivers.DriverDto
import com.narbase.letsgo.web.dto.passengers.PassengerDto
import com.narbase.letsgo.web.dto.ridephonenumber.RidePhoneNumberDto

class ExtendedRideDto (
    val ride: RideDto,
    val passenger: PassengerDto,
    val driver: DriverDto?,
    val carType: CarTypeDto?,
    val requestedCarType: CarTypeDto?,
    val currency: CurrencyDto?,
    val ridePhoneNumber: RidePhoneNumberDto?
)